/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const DownloadFilled: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="download-filled" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M1076.6666666666665 1190A113.3333333333333 113.3333333333333 0 0 0 1190 1076.6666666666667V283.3333333333335A113.3333333333333 113.3333333333333 0 0 0 1076.6666666666665 170H170V1076.6666666666667A113.3333333333333 113.3333333333333 0 0 0 283.3333333333333 1190H623.3333333333333V642.0333333333334L476.5666666666667 788.2333333333333L396.6666666666667 708.3333333333334L680 425L963.3333333333331 708.3333333333334L883.4333333333333 788.2333333333333L736.6666666666666 642.0333333333334V1190H1076.6666666666665z" : "M861.3333333333334 952A90.6666666666667 90.6666666666667 0 0 0 952 861.3333333333333V226.6666666666667A90.6666666666667 90.6666666666667 0 0 0 861.3333333333334 136H136V861.3333333333333A90.6666666666667 90.6666666666667 0 0 0 226.6666666666667 952H498.6666666666667V513.6266666666667L381.2533333333334 630.5866666666666L317.3333333333334 566.6666666666666L544 340L770.6666666666667 566.6666666666666L706.7466666666667 630.5866666666666L589.3333333333334 513.6266666666667V952H861.3333333333334z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
DownloadFilled.displayName = `Blueprint5.Icon.DownloadFilled`;
export default DownloadFilled;
